module.exports = __webpack_public_path__ + "static/media/threeColumns.233081a1.gif";